import { render, staticRenderFns } from "./ClicBreadcrumb.vue?vue&type=template&id=13f10906&scoped=true&"
import script from "./ClicBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./ClicBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./ClicBreadcrumb.vue?vue&type=style&index=0&id=13f10906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f10906",
  null
  
)

export default component.exports